import React from 'react'
import Masonry from 'react-masonry-css'
import styled from 'styled-components'
import { Box, Flex } from 'components/Layout'
import { COLOR_INTENT, FONT_SIZE, SPACE } from 'Theme'
import { type NavigationItem } from 'types/graphql-generated'
import { DesktopSectionHeading as SectionHeading } from './DesktopSectionHeading'
import { HoverableLinkWithText } from './HoverableLinkWithText'

const StyledMasonry = styled(Masonry)`
  display: flex;
  width: 100%;
  column-gap: ${SPACE.PX_40};
`

const MASONRY_BREAKPOINT_COLS = {
  WITHOUT_SECTION_OF_SUB_ITEMS_WITH_IMAGES: 6,
  WITH_SECTION_OF_SUB_ITEMS_WITH_IMAGES: 4,
}

interface DesktopSectionOfSubItemsWithoutImagesProps {
  section: Array<NavigationItem>
  isSectionOfSubItemsWithImagesShown: boolean
}

export const DesktopSectionOfSubItemsWithoutImages: React.FC<
  React.PWC<DesktopSectionOfSubItemsWithoutImagesProps>
> = ({ section, isSectionOfSubItemsWithImagesShown }) => (
  <StyledMasonry
    breakpointCols={
      !isSectionOfSubItemsWithImagesShown
        ? MASONRY_BREAKPOINT_COLS.WITHOUT_SECTION_OF_SUB_ITEMS_WITH_IMAGES
        : MASONRY_BREAKPOINT_COLS.WITH_SECTION_OF_SUB_ITEMS_WITH_IMAGES
    }
  >
    {section.map(({ id, title, cmsPage: { href }, children }) => (
      <Flex key={id} flexDirection="column" mb={SPACE.PX_16}>
        <SectionHeading href={href}>{title}</SectionHeading>
        {children.map(
          ({
            id: childId,
            title: childTitle,
            cmsPage: { href: childHref },
          }) => (
            <Box key={childId} mb={SPACE.PX_16}>
              <HoverableLinkWithText
                color={COLOR_INTENT.HEADER.ITEM_WITH_IMAGE_TEXT.DEFAULT}
                href={childHref}
                fontSize={FONT_SIZE.PX_15}
              >
                {childTitle}
              </HoverableLinkWithText>
            </Box>
          )
        )}
      </Flex>
    ))}
  </StyledMasonry>
)
